<template>
  <div>
    <div v-if="!polling && videos.length == 0">
      This user has not uploaded any videos yet.
    </div>
    <div
      class="mt-4 bg-gray-50 border border-gray-200 flex items-center content-center justify-center py-24"
      v-if="polling"
    >
      <DotPulse />
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <AdminVideoCard
        v-for="video in videos"
        :video="video"
        v-bind:key="video.id"
      />
    </div>
  </div>
</template>

<script>
import * as Config from "@/config";
import AdminVideoCard from "@/components/AdminVideoCard";
import DotPulse from "@/components/Loaders/DotPulse";

export default {
  name: "AdminUsers",
  props: ["userData"],
  components: { AdminVideoCard, DotPulse },
  data() {
    return {
      polling: true,
      videos: []
    };
  },
  mounted() {
    this.getVideos();
  },
  methods: {
    async getVideos() {
      this.$set(this, "polling", true);
      let res = await this.$http.get(
        Config.apiPath + "/api/v2/admin/users/" + this.userData.id + "/videos"
      );
      this.$set(this, "videos", res.data.data);
      this.$set(this, "polling", false);
    }
  }
};
</script>
